import { otpVerificationImage, otpVerificationImageAlHalal } from "assets";
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "utils/showToast";
import { signInLocal } from "store/services/Authentication";
import { signUp } from "store/actions/Authentication";
import { usePhoneVerification } from "hooks/usePhoneVerification";
import { MAVENCERY_STORES_NAMES } from "constants";

const OtpVerification = () => {
  const { result, formData, phone } = useSelector((state) => state.otp);
  const { selectedStore } = useSelector((store) => store.selectedStore);
  const { resendOTPHandler, phoneVerificationError, cooldown } =
    usePhoneVerification(phone, formData);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");

  const length = 6;
  const inputRefs = useRef([]);
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(phoneVerificationError);

  const handleOtpChange = (e, index) => {
    setError("");
    const { value } = e.target;
    if (isNaN(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1);
    setOtp(newOtp);
    if (value && index < length - 1 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
    if (
      value &&
      index < length - 2 &&
      inputRefs.current[index + 2] &&
      otp[index + 1] &&
      !otp[index + 2]
    ) {
      inputRefs.current[index + 2].focus();
    }
  };

  const handleClick = (index) => {
    inputRefs.current[index].setSelectionRange(1, 1);
    if (index && !otp[index - 1]) {
      inputRefs.current[otp.indexOf("")].focus();
    }
  };
  const handleOnKeyDown = (e, index) => {
    if (
      e.key === "Backspace" &&
      index > 0 &&
      !otp[index] &&
      inputRefs.current[index - 1]
    ) {
      inputRefs.current[index - 1].focus();
    }
  };

  const verifyOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const combinedOtp = otp.join("");
    if (combinedOtp === "" || combinedOtp.length !== length) {
      setError("Please enter a valid OTP.");
      setLoading(false);
      return;
    }
    try {
      const res = await result?.confirm(combinedOtp);
      if (res) {
        showToast("OTP verified successfully", "success", true);
        let userSignup = {
          uid: res.user.uid,
          metaData: res.user.metaData,
          providerData: res.user.providerData,
          photoUrl: res.user.photoURL,
          accessToken: res.user.accessToken,
          refreshToken: res.user.refreshToken,
          first_name: formData.firstName,
          last_name: formData.lastName,
          email: formData.email,
          phoneNo: phone,
          isWhiteLabel: selectedStore?.isWhiteLabel === true ? true : false,
          storeId:
            selectedStore?.isWhiteLabel === true ? selectedStore?.id : null,
        };
        let user = await signInLocal(userSignup);
        user = {
          ...user,
          accessToken: userSignup.accessToken,
        };
        if (user.success === true) {
          dispatch(signUp(user));
          if (type === "login") {
            showToast(
              `Welcome back, Logged in successfully. `,
              "success",
              true
            );
            navigate(`/stores/${selectedStore?.id}/dashboard`);
          } else {
            showToast(`User created successfully.`, "success", true);
            if (selectedStore?.isWhiteLabel === true) {
              navigate(`/stores/${selectedStore?.id}/dashboard`);
            } else {
              navigate(`/users/${user?.data.id}/preferences`);
            }
          }
        } else {
          throw new Error(user.message || "Failed to create user");
        }
      }
    } catch (err) {
      console.error("Error verifying OTP:", err);
      setError("Invalid OTP entered!");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  return (
    <div className="flex items-center justify-center h-screen min-h-screen ">
      <div
        className={`flex md:flex-col lg:flex-row flex-col lg:items-center   gap-0 lg:justify-center  extraMedium:gap-12 items-center  w-full justify-center  bg-white md:mx-36 lg:mx-36 h-4/5 extraMedium:mx-12 extraMedium:h-2/4 extraMedium:items-center extraMedium:justify-center   extraMedium:w-full ${
          !selectedStore?.isWhiteLabel
            ? "lg:bg-lightBlueColor md:bg-white md:shadow-gray-shadow"
            : selectedStore?.isWhiteLabel &&
              selectedStore.name === MAVENCERY_STORES_NAMES.AlHalalMeats
            ? "lg:bg-lightOrangeColor md:bg-white md:shadow-gray-shadow"
            : "lg:bg-lightBlueColor md:bg-white md:shadow-gray-shadow"
        }`}
      >
        <div className="w-[50%] lg:w-[50%] md:w-full md:mx-auto extraMedium:w-[50%]  ">
          <div className="lg:w-[80%] lg:m-auto md:w-72 md:mt-32 md:mx-auto mx-auto  md:h-72 h-72  lg:h-2/3  extraMedium:w-[100%] extraMedium:mt-0  flex justify-center items-center  ">
            <img
              className="object-cover h-full my-auto "
              src={
                selectedStore?.isWhiteLabel
                  ? otpVerificationImageAlHalal
                  : otpVerificationImage
              }
              alt="otpVerificationImage"
            ></img>
          </div>
        </div>
        <div className="lg:w-[50%] w-[100%] h-full md:w-full flex justify-center lg:items-center lg:justify-start lg:ml-12 md:items-start items-start extraMedium:w-[50%] extraMedium:mx-0 ">
          <div
            className={`flex flex-col md:mt-8 lg:mt-0 sm:mt-0 items-center justify-center lg:justify-center md:justify-start text-center bg-white  rounded-lg w-[80%] lg:w-[80%] md:w-2/3 h-4/5 extraMedium:w-[80%]`}
          >
            <form onSubmit={verifyOtp}>
              <h4 className="text-3xl font-bold">OTP Verification</h4>
              <p>Enter OTP Code sent to {phone}</p>
              <div className="my-6">
                {otp.map((value, index) => (
                  <input
                    key={index}
                    ref={(el) => (inputRefs.current[index] = el)}
                    value={value}
                    onChange={(e) => handleOtpChange(e, index)}
                    onClick={() => handleClick(index)}
                    onKeyDown={(e) => handleOnKeyDown(e, index)}
                    className="w-10 h-10 m-1 text-center border border-black "
                  />
                ))}
              </div>
              <div className="my-6">
                <p>Didn't receive OTP code?</p>
                <div
                  className={`${
                    cooldown > 0
                      ? ""
                      : "font-semibold text-blue-900 hover:text-blue-300"
                  }`}
                  onClick={resendOTPHandler}
                  disabled={cooldown > 0}
                >
                  {cooldown > 0 ? (
                    <span>
                      Resend OTP in{" "}
                      <span className="font-bold text-red-500">
                        00:{cooldown < 10 ? "0" : ""}
                        {cooldown}
                      </span>
                    </span>
                  ) : (
                    "Resend OTP"
                  )}
                </div>
              </div>
              {error && <p className="mb-2 text-red-500">{error}</p>}
              <button
                onClick={verifyOtp}
                className={`w-[92%] px-3 py-2 text-white ${
                  selectedStore?.isWhiteLabel
                    ? "bg-orangeColor"
                    : "bg-theme-color"
                } hover:font-semibold `}
                disabled={loading}
              >
                {loading ? "Verifying..." : "Verify & Proceed"}
              </button>
            </form>
          </div>
        </div>
      </div>
      <div id="recaptcha-container"></div>
    </div>
  );
};

export default OtpVerification;
